import { toast } from "react-toastify";

import { getNotifMsg } from "./message";

// NOTE: This function is used multiple places, be careful when making changes and check for side effects
export const handleRequestErrors = (response, locale = "fa") => {
  const statusCode = response && response.status;
  if (statusCode === 500) {
    toast.error(getNotifMsg("SERVER_ERROR", locale));
  } else if (statusCode === 401) {
    toast.error(getNotifMsg("WRONG_ENTERED_INFO", locale));
  } else if (statusCode === 429) {
    toast.error(getNotifMsg("TOO_MANY_REQUEST", locale));
  } else if (statusCode === 404) {
    toast.error(getNotifMsg("CONTENT_NOT_FOUND", locale));
  } else if (statusCode === 400) {
    toast.error(getNotifMsg("SENT_REQUEST_NOT_CORRECT", locale));
  } else if (statusCode === 422) {
    if (response?.data._original?.type === "email") {
      toast.error(getNotifMsg("WRONG_ENTERED_EMAIL", locale));
      return;
    }
    toast.error(getNotifMsg("WRONG_ENTERED_PHONE", locale));
  }
};
